export default function CTAFinal() {
  return (
    <section className="bg-gradient-to-br from-md-dark to-md-blue py-16 md:py-20">
      <div className="mx-auto max-w-[700px] px-6 text-center md:px-12">
        <h2 className="mb-10 font-serif text-[28px] font-bold text-white md:text-[38px]">
          Pide tu domicilio ahora
        </h2>

        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href="tel:+573206789030"
            className="group relative flex w-full items-center justify-center gap-3 overflow-hidden rounded-xl bg-white py-4 text-[16px] font-semibold text-md-ink transition-all hover:-translate-y-0.5 hover:shadow-[0_0_24px_rgba(255,255,255,0.3)] active:translate-y-0 sm:w-[240px]"
            onClick={() => {
              if (typeof window !== 'undefined' && (window as unknown as Record<string, unknown>).mdCallClick) {
                ((window as unknown as Record<string, unknown>).mdCallClick as () => void)();
              }
            }}
          >
            <span className="flex h-5 w-5 items-center justify-center text-md-dark">
              <i className="ri-phone-line" />
            </span>
            <span className="whitespace-nowrap">Llámanos: 320 678 9030</span>
          </a>
          <a
            href="https://wa.me/573206789030?text=Hola,%20quiero%20pedir%20un%20domicilio"
            target="_blank"
            rel="noopener noreferrer"
            className="flex w-full items-center justify-center gap-3 rounded-xl bg-md-teal py-4 text-[16px] font-semibold text-white transition-all hover:-translate-y-0.5 hover:shadow-[0_0_24px_rgba(20,160,133,0.4)] active:translate-y-0 sm:w-[240px]"
            onClick={() => {
              if (typeof window !== 'undefined' && (window as unknown as Record<string, unknown>).mdWaClick) {
                ((window as unknown as Record<string, unknown>).mdWaClick as () => void)();
              }
            }}
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-whatsapp-line" />
            </span>
            <span className="whitespace-nowrap">WhatsApp</span>
          </a>
        </div>
      </div>
    </section>
  );
}